import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/lexus/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import * as FormStyles from "../../../../../../common-deprecated/styles/v2/lexus/components/Form";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Styles from "./styles/MassManagementStyles";
import * as Image from "../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import Icon, { IconExclamationCircle } from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import useModalMassManagement from "../../../hooks/shared/useModalMassManagement";
import type { MassManagementModalType } from "../../../utils/modalConstants";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonTertiary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonTertiary";
import { useBnbSelector } from "../../../redux/store";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { getCarImageFromConfig } from "../../../../../shared-logic/utils/typedUtils";

type SelectableBaseItemType = { id: string; name: string };
const SelectableItem = <T extends SelectableBaseItemType>({
    item,
    selected,
    onClick,
}: {
    item: T;
    selected: boolean;
    onClick: (item: T, selected: boolean) => void;
}): JSX.Element => {
    return (
        <FormStyles.Checkbox hasLargeText>
            <input type="checkbox" id={`mm-${item.id}`} checked={selected} onChange={() => onClick(item, selected)} />
            <label htmlFor={`mm-${item.id}`}>{item.name}</label>
        </FormStyles.Checkbox>
    );
};

const MassManagementModal = (props: ModalViewType<MassManagementModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { onCancel, onOk, validates, exceedingKilogram, originalBasket, packs, extras, packClick, extraClick } =
        useModalMassManagement(close);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const { model, car } = useBnbSelector((state) => state.navigation);
    const { colour, upholstery, wheel } = originalBasket;

    const imageUrl = getCarImageFromConfig(
        commonSettings,
        "day-exterior",
        9,
        model,
        car || "",
        {
            type: "png",
            width: 615,
            height: 247,
            padding: 0,
        },
        colour,
        upholstery,
        wheel,
        packs,
        extras,
    );

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={onCancel} show={show} size="lg">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="massManagementModalTitle" />
                </Modal.Title>
                <Modal.Button type="button" onClick={onCancel}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body noSpacing>
                <Styles.Visual>
                    <Image.ImageFluid src={imageUrl} />
                </Styles.Visual>
                <Styles.Header>
                    <Styles.Text>
                        <BnbLabel label="massManagementModalDescription" params={{ value: exceedingKilogram }} />
                    </Styles.Text>
                </Styles.Header>
                {/* Summary */}
                <Styles.Content>
                    {/* <Styles.StatisticBar>
                        <Styles.StatItem bg="dark" maxWidth="40%" />
                        <Styles.StatItem bg="grey5" maxWidth="50%" />
                        <Styles.StatItem bg="#B12A31" maxWidth="10%" />
                    </Styles.StatisticBar>
                    <Styles.Legend>
                        <Styles.LegendItem>Car</Styles.LegendItem>
                        <Styles.ExtraLegendItem>Extras</Styles.ExtraLegendItem>
                        <Styles.ExceedLegendItem>Extras that exceed max-weight</Styles.ExceedLegendItem>
                    </Styles.Legend> */}

                    {/* Extras */}
                    <Type.H2 headingType="epsilon">
                        <BnbLabel label="massManagementModalSelectedItemsTitle" />
                    </Type.H2>
                    <Styles.Text>
                        {validates ? (
                            <BnbLabel label="massManagementModalSelectedItemsValidates" />
                        ) : (
                            <>
                                <IconWrapper size="lg" mr={1}>
                                    <IconExclamationCircle />
                                </IconWrapper>
                                <BnbLabel
                                    label="massManagementModalSelectedItemsError"
                                    params={{ value: exceedingKilogram }}
                                />
                            </>
                        )}
                    </Styles.Text>
                    <Styles.Form>
                        {originalBasket.packs.map((pack) => (
                            <SelectableItem
                                key={pack.id}
                                item={pack}
                                selected={!!packs.find((selectedPack) => selectedPack.id === pack.id)}
                                onClick={packClick}
                            />
                        ))}
                        {originalBasket.extras.map((extra) => (
                            <SelectableItem
                                key={extra.id}
                                item={extra}
                                selected={!!extras.find((selectedExtra) => selectedExtra.id === extra.id)}
                                onClick={extraClick}
                            />
                        ))}
                    </Styles.Form>
                </Styles.Content>
                <Styles.Actions>
                    <ButtonTertiary onClick={onCancel}>
                        <BnbLabel label="massManagementModalCancel" />
                    </ButtonTertiary>
                    <ButtonPrimary onClick={onOk}>
                        <BnbLabel label="massManagementModalOk" />
                    </ButtonPrimary>
                </Styles.Actions>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default MassManagementModal;
